export const SET_ADMIN_EXTRA_DATA = 'SET_ADMIN_EXTRA_DATA'
export const SET_EDITING_USER_TYPE = 'SET_EDITING_USER_TYPE'
